import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { Button } from '@sbt-web/ui';
import styles from '../index.module.scss';
export interface SendOfferButtonProps {
  onClick: () => void;
  classes?: string[];
  isSecondary?: boolean;
}
export const SendOfferButton = t0 => {
  const $ = _c(8);
  const {
    onClick,
    classes,
    isSecondary
  } = t0;
  let t1;
  if ($[0] !== classes) {
    t1 = classnames(classes, styles["send-offer-button"]);
    $[0] = classes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = [t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isSecondary ? "outline" : "solid";
  let t4;
  if ($[4] !== onClick || $[5] !== t2 || $[6] !== t3) {
    t4 = <Button classes={t2} size="large" onClick={onClick} design={t3}>Fai una Proposta</Button>;
    $[4] = onClick;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};